module.exports = __webpack_public_path__ + "media/paywall-video-female-alternative.fc29428d.mp4";